import React, { useEffect, useState } from "react";
import "../styles/projects.css";
import ProjectCard from "../components/ProjectCard";

const Projects = () => {
  const [projects, setProjects] = useState([]);

  const callProjectsPage = async () => {
    try {
      const res = await fetch("https://portfolio-server-ojasketkar.vercel.app/getAllProjects", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();
      setProjects(data.data);

      if (!res.status === 200) {
        const error = new Error(res.error);
        throw error;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    callProjectsPage();
  }, []);

  return (
    <div className="projects">
      <h4 className="projects-tagline">Passion In Progress</h4>
      <h1 className="projects-header">My Work</h1>

      <div className="projects-grid">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
